// Direct-request function references (bead hf-e6-commitments-coverage-udt.1).
//
// The whole lifecycle in one place: ask, answer, un-ask, and the two reads that let
// each side see the state of the question.
//
// WHAT IS NOT HERE, and cannot be: anything that expires a request. Expiry is derived
// on read (`convex/domain/requests.ts:isOpen`) and materialised by an INTERNAL
// scheduled mutation, so there is no client-callable expiry and no way for a browser
// to decide that somebody's ask has run out of time. A lapsed ask simply stops
// appearing in `myRequests` and starts appearing in `requestsForNeed`'s `lapsed` list.

import { api } from "../../../../convex/_generated/api";

export const requestMutations = {
  /** Ask one named person. Moves no coverage — see the module it calls. */
  send: api.domain.requests.send,
  /** Yes or no, from the person who was asked. */
  respond: api.domain.requests.respond,
  /** The organiser takes the question back (REQ-010). */
  withdraw: api.domain.requests.withdraw,
} as const;

export const requestQueries = {
  /** The caller's own open asks. "Mine" is resolved at the boundary, never passed in. */
  myRequests: api.domain.requests.myRequests,
  /** Every ask on one need, sorted into what the organiser can act on (REQ-011). */
  requestsForNeed: api.domain.requests.requestsForNeed,
} as const;
